import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import FuseUtils from '@/@fuse/utils';
import SuperAdminConfig from '@/app/main/superadmin/superAdminConfig';
import pagesConfigs from '@/app/main/pages/pagesConfigs';
import subAdminConfig from '@/app/main/subadmin/subAdminConfig';
import secureLocalStorage from 'react-secure-storage';
import FuseLayout from '@/@fuse/core/FuseLayout/FuseLayout';

const publicRoutes = pagesConfigs.filter(
	(config) =>
		config.auth === null ||
		['/login', '/forgot-password', '/reset-password', '/password/reset', '/404', '/500', '/otp', '/success'].some(
			(path) => config.routes.some((route) => route.path === path)
		)
);

const privateRoutes = [
	...pagesConfigs.filter((config) => !publicRoutes.includes(config)),
	...subAdminConfig,
	...SuperAdminConfig,
];

const RootRedirect = () => {
	const role = JSON.parse(secureLocalStorage.getItem('user'))?.role[0];
	if (['super_admin', 'company_owner', 'product_owner'].includes(role)) {
		return <Navigate replace to="/company" />;
	}
	if (['super_school_admin', 'school_admin', 'sub_admin'].includes(role)) {
		return <Navigate replace to="/home" />;
	}
	return <Navigate replace to="/login" />;
};

// Root layout that will contain all authenticated routes
const RootLayout = () => {
	return (
		<FuseLayout>
			<Outlet />
		</FuseLayout>
	);
};

const routes = [
	// Public routes (no layout wrapper)
	...FuseUtils.generateRoutesFromConfigs(publicRoutes),

	// Private routes (with layout wrapper)
	{
		element: <RootLayout />,
		children: [
			...FuseUtils.generateRoutesFromConfigs(privateRoutes),
			// Root redirect
			{
				path: '/',
				element: <RootRedirect />,
			},
		],
	},
	// 404 route
	{
		path: '*',
		element: <Navigate replace to="/404" />,
	},
];

export default routes;
